export default "__VITE_ASSET__aKLqnBRJ__"